import { defineMessages } from 'react-intl'

export default defineMessages({
  reports: {
    id: 'containers.CustomerReportsPage.reports',
    defaultMessage: 'Reports',
  },
  reportsExplanation: {
    id: 'containers.CustomerReportsPage.reportsExplanation',
    defaultMessage: 'Reports gives you an overview of purchase orders and usage for the current last 30 days compared to the past 30 days before that.',
  },
})